import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["active", "checkbox", "fieldset", "inactive"];

  declare activeTarget: HTMLElement;
  declare checkboxTarget: HTMLInputElement;
  declare fieldsetTarget: HTMLFieldSetElement;
  declare inactiveTarget: HTMLElement;

  initialize() {
    this.toggle("true");
  }

  toggle(loading = "false") {
    const checkbox = this.checkboxTarget;
    const childContent = this.fieldsetTarget;
    const active = this.activeTarget;
    const inactive = this.inactiveTarget;

    // Loading here refers to the initial state of the page, so we reconcile
    // that state with the UI.
    if (loading !== "true") {
      // Attempting to work directly with `checkbox.checked` seems to break the page.
      // Using the `checkbox.attributes["checked"]` yields better results, but not for
      // toggles that were checked on page load.
      checkbox.dataset["selected"] = checkbox.dataset["selected"] === "true" ? "false" : "true";
    }

    // We make use of the `data-selected` attribute on the checkbox here to track
    // the state of the toggle. If we do this directly within the DOM, we are unable
    // to set `checkbox.checked` when being interacted with. Not setting it in the DOM
    // let's us have free use of it.
    if (checkbox.dataset["selected"] === "true") {
      checkbox.checked = true;
    } else {
      checkbox.checked = false;
    }

    // Switching between the states requires making 3 DOM changes
    // this is heavily because the toggle button visibly is 2 separate
    // spans, and then the content is another element
    if (checkbox.checked) {
      active.classList.remove("hidden");
      inactive.classList.add("hidden");
      childContent.classList.remove("hidden");
    } else {
      active.classList.add("hidden");
      inactive.classList.remove("hidden");
      childContent.classList.add("hidden");
    }
  }
}
